class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.trigger = document.getElementById('infinite-scroll-trigger');
    this.productGrid = document.getElementById('product-grid');
    this.loadingSpinner = this.trigger.querySelector('.loading-spinner');
    this.currentPage = 1;
    this.isLoading = false;

    this.setupObserver();
  }

  setupObserver() {
    const options = {
      root: null,
      rootMargin: '100px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadMoreProducts();
        }
      });
    }, options);

    observer.observe(this.trigger);
  }

  async loadMoreProducts() {
    this.isLoading = true;
    this.loadingSpinner.classList.remove('hide');
    
    const nextPage = this.currentPage + 1;
    const url = `${window.location.pathname}?page=${nextPage}&section_id=${this.dataset.sectionId}`;

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newProducts = html.getElementById('product-grid').innerHTML;

      this.productGrid.insertAdjacentHTML('beforeend', newProducts);
      this.currentPage = nextPage;
      
      if (this.currentPage >= this.dataset.totalPages) {
        this.trigger.remove();
      }
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      this.isLoading = false;
      this.loadingSpinner.classList.add('hide');
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll); 